import { FC } from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { TranslationProvider } from "rujira.ui";
import { BorrowPositionsTable } from "../../borrow/components/BorrowPositionsTable";
import { usePreloadedAccountData } from "../../services/accountData";
import { PositionsPortfolioFragment$key } from "./__generated__/PositionsPortfolioFragment.graphql";

const fragment = graphql`
  fragment PositionsPortfolioFragment on Account {
    credit {
      accounts {
        ...BorrowPositionsTableFragment
      }
    }
  }
`;

export const Positions: FC = () => {
  const { accountData } = usePreloadedAccountData();
  const data = useFragment<PositionsPortfolioFragment$key>(
    fragment,
    accountData
  );
  return (
    <div className="borrow relative card p-3 mt-2">
      {data?.credit.accounts?.length ? (
        <TranslationProvider namespace="borrow">
          <BorrowPositionsTable
            accounts={data.credit.accounts}
            adjustmentThreshold={1n}
          />
        </TranslationProvider>
      ) : (
        <p className="condensed fs-14 color-grey text-center mt-2">
          You have no open borrowing positions
        </p>
      )}
    </div>
  );
};
